import { render, staticRenderFns } from "./TeacherSendRecognitionsCard.vue?vue&type=template&id=29a7e21a&"
import script from "./TeacherSendRecognitionsCard.vue?vue&type=script&lang=js&"
export * from "./TeacherSendRecognitionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports